module.exports = __webpack_public_path__ + "media/images/shared/suppliers/DONALDSON-eebea779226fcd67d2076abb3ec93fa5.jpg";